import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

import type { PerronCoinsMeSummary } from '../../../shared/models/perron-points.model';
import { ApiService } from '../../../shared/services/api.service';

/** Movimientos por página de «Mis Coins». La API admite 1-100 (`PerronPointController`). */
export const PROFILE_COINS_PER_PAGE = 10;

/**
 * Lectura propia de la pestaña «Mis Coins» (A0·web, W10): `GET /perron-points/me` paginado, con `lifetime_earned` y
 * `coin_value_crc` (D6). `PointsService` sigue siendo la fuente del saldo global (cabecera, gates) y no se toca.
 */
@Injectable({ providedIn: 'root' })
export class ProfileCoinsService {
  private readonly api = inject(ApiService);

  page(page: number): Observable<PerronCoinsMeSummary> {
    return this.api.get<PerronCoinsMeSummary>('/perron-points/me', { page, per_page: PROFILE_COINS_PER_PAGE });
  }
}
